module.exports = "/18b5fb0de9b03fffbdcc4d7794d6f4ee.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/feature-4-2.png
 ** module id = 2215
 ** module chunks = 0
 **/